import { Article } from "../../types";

export default (articles: Array<Article>) => Array.from(new Set(articles.map((article) => article.category)));
